import { Screen } from '~/screens/client-contracts';

export const ClientContractListIndex = () => <Screen />;
